import { render, staticRenderFns } from "./AskAI.vue?vue&type=template&id=31977538&scoped=true&"
import script from "./AskAI.vue?vue&type=script&lang=js&"
export * from "./AskAI.vue?vue&type=script&lang=js&"
import style0 from "./AskAI.vue?vue&type=style&index=0&id=31977538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31977538",
  null
  
)

export default component.exports